export const SIDE_NAV_WIDTH = 280
export const SIDE_NAV_COLLAPSED_WIDTH = 72
export const TOP_NAV_HEIGHT = 64
